module.exports = __webpack_public_path__ + "img/from-signal-to-symbol--the-evolution-of-language-cover.2796782c.jpg";